<template lang='pug'>
#app
  Navbar(
    :token="token"
    :key='$route.fullPath'
    :userProfile="userProfile"
    :loginStatus="data.loginStatus"
  )
  .mainWrapper
    .mainwrapper-menu
      SideMenu(
        type="users"
        :token='token'
        :key="$route.fullPath"
        :sidemenu='data.sidemenu'
        :userProfile="userProfile"
        :loginStatus="data.loginStatus"
      )
    .mainWrapper-content
      Banner
      router-view(
        :data='data'
        :key="$route.fullPath"
        :breadcrumbList='breadcrumbs'
      )
      BottomBanner(v-if='isMain' :bannerBottomShowBigScreens="false")
  GoToTop
  Footer(
    :elements='data.footer.elements'
    :copyright='data.footer.copyright'
  )
</template>

<script>
import StaticData from '@/assets/data.json'
import Navbar from '@/components/nav/navbar.vue'
import Banner from '@/components/banner.vue'
import SideMenu from '@/components/menu/side_menu.vue'
import BottomBanner from '@/components/bottom_banner.vue'
import GoToTop from '@/components/modules/mobile/go_to_top.vue'
import Footer from '@/components/footer.vue'
import { getUserProfile } from '@/plugins/login.js'

export default {
  components: {
    Navbar,
    Banner,
    SideMenu,
    BottomBanner,
    GoToTop,
    Footer
  },
  data() {
    return {
      data: null,
      token: null,
      breadcrumbs: [{text: '首頁', link: '/'}],
      userProfile: {
        displayName: null,
        pictureUrl: null,
        userId: null
      },
      loginStatus: "登入",
      storageKeys: this.$store.state.storageKeys
    }
  },
  created() {
    this.data = StaticData[this.$store.state.lang]
  },
  computed: {
    isMain() {
      return this.$route.path === '/'
    }
  },
  mounted() {
    // eslint-disable-next-line
    if (liff.isInClient()) {
      // eslint-disable-next-line
      liff.init({
        liffId: process.env.VUE_APP_LIFFID  // Use own liffId
      }).then(() => {
        this.getUserProfileByLiff()
      }).catch((err) => {
        // eslint-disable-next-line
        console.log('liff init error: ', err)
      });
    }
    if (this.token == null) {
      const userInfo = getUserProfile(this.$store.state.storageKeys)
      this.token = userInfo[0]
      this.userProfile.displayName = userInfo[1]
      this.userProfile.pictureUrl = userInfo[2]
    }
  },
  methods: {
    async getUserProfileByLiff() {
      this.$store.commit('liffEnable')
      // eslint-disable-next-line
      this.token = liff.getAccessToken();
      let res = await this.$axios.get(
        this.$store.state.URLs.loginApi + this.$store.state.routes.getAccessTokenByLiff,
        {
          headers: {
            "Authorization": "Bearer " + this.token
          }
        }
      ).catch(err => {
        // eslint-disable-next-line
        console.log('getUserProfileByLiff error: ', err)
      })
      localStorage.setItem(this.storageKeys.token, res.data.accessToken)
      localStorage.setItem(this.$store.state.storageKeys.identity, "users")
      // eslint-disable-next-line
      liff.getProfile()
      .then(profile => {
        this.userProfile.pictureUrl = profile.pictureUrl
        this.userProfile.displayName = profile.displayName
        this.userProfile.userId = profile.userId
        localStorage.setItem(this.$store.state.storageKeys.pictureUrl, this.userProfile.pictureUrl)
        localStorage.setItem(this.$store.state.storageKeys.displayName, this.userProfile.displayName)
        localStorage.setItem(this.$store.state.storageKeys.id, this.userProfile.userId)
      })
      .catch((err) => {
        // eslint-disable-next-line
        console.log('liff getProfile error: ', err);
      });
    }
  }
}
</script>
<style src='./user.vue.css'></style>
